<div class="billing-documents-pdf-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">

        <span class="text-purple-manax text-capitalize title-modal" *ngIf="document">
          Factura {{document.serieAndNumber}}
        </span>

        <span class="text-purple-manax text-capitalize title-modal" *ngIf="correctiveInvoice">
          Factura Rectificadora {{correctiveInvoice.serie + '-0000' + correctiveInvoice.number}}
        </span>

        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="pull-right">
          <select class="filter small" [(ngModel)]="printType" (ngModelChange)="printTypeChange()">
            <option [ngValue]="'extended'"> Impresión Factura Extendida </option>
            <option [ngValue]="'simple'"> Impresión Factura Simple </option>
            <option [ngValue]="'receipt'" *ngIf="this.document?.receipt"> Impresión Recibo </option>
          </select>
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row">
    <div class="col-12">
      <ngx-extended-pdf-viewer [src]="src ?? ''" [height]="'auto'"
        [filenameForDownload]="fileNameDownload">
      </ngx-extended-pdf-viewer><!-- [useBrowserLocale]="true" -->
    </div>
  </div>
</div>